/**
 * ADR-0087: every dialog and side sheet is a header, a body, and a footer. Outside production this
 * reports a popup that renders content outside those parts, so tests fail instead of users scrolling.
 */
export function checkPanelStructure(node: HTMLElement | null, kind: "Dialog" | "Sheet") {
  if (!node || import.meta.env.MODE === "production") return;
  // A closing popup keeps its frame while its content is already gone; only an open one is checked.
  if (node.hasAttribute("data-closed") || node.hasAttribute("data-ending-style")) return;
  const content = [...node.children].filter((child) => !child.matches("[data-slot=dialog-close]"));
  if (content.length === 0) return;
  const loose = [...node.children].filter(
    (child) =>
      !child.matches(
        "[data-slot=dialog-header],[data-slot=dialog-body],[data-slot=dialog-footer],[data-slot=dialog-form],[data-slot=dialog-close]",
      ),
  );
  const missing = ["header", "body", "footer"].filter(
    (part) => node.querySelector(`[data-slot=dialog-${part}]`) === null,
  );
  if (loose.length || missing.length)
    console.error(
      `[ADR-0087] ${kind} "${node.querySelector("[data-slot=dialog-header]")?.textContent ?? ""}" must be built from its Header, Body, and Footer parts (missing: ${missing.join(", ") || "none"}; ${loose.length} loose elements).`,
    );
}

/** Stable ref callbacks, so the structure is checked once when a popup opens, not on every render. */
export const dialogStructureRef = (node: HTMLDivElement | null) => {
  checkPanelStructure(node, "Dialog");
};
export const sheetStructureRef = (node: HTMLDivElement | null) => {
  checkPanelStructure(node, "Sheet");
};
